import type CatalogsBreadcrumb from '../store/schema/CatalogsBreadcrumb';
import type AddCalendarsMenuItemId from '../store/schema/AddCalendarsMenuItemId';

export default function createBreadcrumbForCatalogs(
    scenarioId: AddCalendarsMenuItemId,
    id: string,
    name?: string
) {
    return <CatalogsBreadcrumb>{
        scenarioId: scenarioId,
        subscriptionId: id,
        name: name,
    };
}
